import Vue from 'vue';
import Component from 'vue-class-component';
import Ribbon from '@/core/ribbon/ribbon.vue';
import JhiFooter from '@/core/jhi-footer/jhi-footer.vue';
import JhiNavbar from '@/core/jhi-navbar/jhi-navbar.vue';

import '@/shared/config/dayjs';

// BEGIN SPE Custom components
import AppBar from '@/core/spe/app-bar/app-bar.vue';
import LeftDrawer from '@/core/spe/left-drawer/left-drawer.vue';
import SpeBottomNavigation from '@/core/spe/spe-bottom-navigation/spe-bottom-navigation.vue';
import LoginService from '@/account/login.service';
import {
  GoRightComponent as GoRight,
  GoRightDrawerComponent as GoRightDrawer,
  GoAlertStackComponent as GoAlertStack,
} from '@gv/ammo-grome';
import { Inject } from 'vue-property-decorator';
import SpeVToast from '@/core/spe/v-toast/spe-v-toast.vue';
// End SPE Custom components

// Begin SPE define inactivity time
const INACTIVITY_WARNING_TIMEOUT = 240000; // 4 minutes — show warning dialog
const COUNTDOWN_SECONDS = 60; // 60-second countdown in dialog
// End SPE define inactivity time

@Component({
  components: {
    /* BEGIN SPE
    ribbon: Ribbon,
    'jhi-navbar': JhiNavbar,

    'jhi-footer': JhiFooter,
    */
    'marut-app-bar': AppBar,
    'marut-left-drawer': LeftDrawer,
    'go-right': GoRight,
    'go-right-drawer': GoRightDrawer,
    'go-alert-stack': GoAlertStack,
    'spe-bottom-navigation': SpeBottomNavigation,
    'spe-v-toast': SpeVToast,
    /* END SPE */
  },
})
export default class App extends Vue {
  // BEGIN SPE
  @Inject('loginService')
  private loginService!: () => LoginService;

  private drawer = false;

  private drawerRight = false;

  private right = false;

  private left = false;

  private warningTimer: any = null;

  private countdownInterval: any = null;

  public showInactivityDialog = false;

  public countdownSeconds = COUNTDOWN_SECONDS;

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  /*
   * Set inactivity timer
   */
  mounted() {
    // @ts-ignore
    this.$root.$vToast = this.$refs.vToast;
    this.setupInactivityTimer();
    window.addEventListener('mousemove', this.resetInactivityTimer);
    window.addEventListener('keydown', this.resetInactivityTimer);
    window.addEventListener('touchstart', this.resetInactivityTimer);
  }

  destroyed() {
    window.removeEventListener('mousemove', this.resetInactivityTimer);
    window.removeEventListener('keydown', this.resetInactivityTimer);
    window.removeEventListener('touchstart', this.resetInactivityTimer);
    clearTimeout(this.warningTimer);
    clearInterval(this.countdownInterval);
  }

  setupInactivityTimer() {
    this.warningTimer = setTimeout(() => {
      if (this.$store.getters.authenticated) {
        this.showInactivityDialog = true;
        this.countdownSeconds = COUNTDOWN_SECONDS;
        this.countdownInterval = setInterval(() => {
          this.countdownSeconds--;
          if (this.countdownSeconds <= 0) {
            this.performLogout();
          }
        }, 1000);
      }
    }, INACTIVITY_WARNING_TIMEOUT);
  }

  resetInactivityTimer() {
    // Don't reset while the warning dialog is shown — user must click a button
    if (this.showInactivityDialog) return;
    clearTimeout(this.warningTimer);
    this.setupInactivityTimer();
  }

  public stayLoggedIn() {
    clearTimeout(this.warningTimer);
    clearInterval(this.countdownInterval);
    this.showInactivityDialog = false;
    this.setupInactivityTimer();
  }

  public performLogout() {
    clearTimeout(this.warningTimer);
    clearInterval(this.countdownInterval);
    this.showInactivityDialog = false;
    this.loginService().logout();
    if (this.$route.path !== '/') {
      this.$router.push('/');
    }
  }
  // END SPE
}
